import { TemplateMail } from '@/enum/TemplateMail'
import { AloUserIdentity, getDefaultAloUserIdentity } from './AloUserIdentity'


//Représente des informations d'indentification d'un utilisateur
export interface AloForgottenPass extends AloUserIdentity {    
    userNewPass:string
    userEncryptedToken?:string   
    userNom?:string 
    famId?:number
    userType?:string
    mtpId:TemplateMail|null
}

export const getDefaultAloForgottenPass = ():AloForgottenPass => {
    return {   
        ...getDefaultAloUserIdentity(),        
        userNewPass:"",
        userEncryptedToken:"",
        userNom:"",
        userType:"Particulier",
        mtpId:null
    }
}